import request from '@/utils/request'

export function register(data) {
  return request({
    url: '/pub/uac/user/register',
    method: 'post',
    data,
    loading: true,
    transformRequest: data => {
      let index = 0
      let ret = ''

      for (const it in data) {
        if (data[it] !== undefined) {
          if (index > 0) {
            ret += '&'
          }
          if (data[it] !== null && data[it] !== undefined) {
            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it])
            index++
          }
        }
      }
      return ret
    },

    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

export function checkNeedImgVCode(data) {
  return request({
    url: '/pub/uac/user/checkNeedImgVCode',
    method: 'post',
    data,
    loading: true,
    transformRequest: data => {
      let index = 0
      let ret = ''

      for (const it in data) {
        if (data[it] !== undefined) {
          if (index > 0) {
            ret += '&'
          }
          if (data[it] !== null && data[it] !== undefined) {
            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it])
            index++
          }
        }
      }
      return ret
    },

    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

export function registerByUserName(data) {
  return request({
    url: '/pub/uac/user/registerByUserName',
    method: 'post',
    data,
    loading: true,
    transformRequest: data => {
      let index = 0
      let ret = ''

      for (const it in data) {
        if (data[it] !== undefined) {
          if (index > 0) {
            ret += '&'
          }
          if (data[it] !== null && data[it] !== undefined) {
            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it])
            index++
          }
        }
      }
      return ret
    },

    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

export function loginByDevice(data) {
  return request({
    url: '/pub/uac/user/loginByDevice',
    method: 'post',
    loading: true,
    auth: {
      username: 'web_user',
      password: 'fghfaacb0099f8efgvjhsdjksajkfd#@2d5a0'
    },
    data,
    transformRequest: data => {
      let index = 0
      let ret = ''

      for (const it in data) {
        if (data[it] !== undefined) {
          if (index > 0) {
            ret += '&'
          }
          if (data[it] !== null && data[it] !== undefined) {
            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it])
            index++
          }
        }
      }
      return ret
    },

    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

export function switchUser(data) {
  return request({
    url: '/user/uac/userInfo/switchByUserId',
    method: 'post',
    loading: true,
    auth: {
      username: 'web_user',
      password: 'fghfaacb0099f8efgvjhsdjksajkfd#@2d5a0'
    },
    data,
    transformRequest: data => {
      let index = 0
      let ret = ''

      for (const it in data) {
        if (data[it] !== undefined) {
          if (index > 0) {
            ret += '&'
          }
          if (data[it] !== null && data[it] !== undefined) {
            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it])
            index++
          }
        }
      }
      return ret
    },

    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

export function login(data) {

  return request({
    url: '/pub/uac/user/loginByUserName',
    method: 'post',
    loading: true,
    auth: {
      username: 'web_user',
      password: 'fghfaacb0099f8efgvjhsdjksajkfd#@2d5a0'
    },
    data,
    transformRequest: data => {
      let index = 0
      let ret = ''

      for (const it in data) {
        if (data[it] !== undefined) {
          if (index > 0) {
            ret += '&'
          }
          if (data[it] !== null && data[it] !== undefined) {
            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it])
            index++
          }
        }
      }
      return ret
    },

    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
export function loginByPhone(data) {
  return request({
    url: '/api/login/loginByPhone',
    method: 'post',
    loading: true,
    data
  })
}

export function changePwd(data) {
  return request({
    url: '/user/user/userUser/changePwd',
    method: 'post',
    loading: false,
    data
    // transformRequest: data => {
    //   let index = 0
    //   let ret = ''

    //   for (const it in data) {
    //     if (data[it] !== undefined) {
    //       if (index > 0) {
    //         ret += '&'
    //       }
    //       if (data[it] !== null && data[it] !== undefined) {
    //         ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it])
    //         index++
    //       }
    //     }
    //   }
    //   return ret
    // },

    // headers: {
    //   'Content-Type': 'application/x-www-form-urlencoded'
    // }
  })
}
export function resetPwd(data) {
  return request({
    url: '/pub/uac/user/resetPassword',
    method: 'post',
    loading: true,
    data,
    transformRequest: data => {
      let index = 0
      let ret = ''

      for (const it in data) {
        if (data[it] !== undefined) {
          if (index > 0) {
            ret += '&'
          }
          if (data[it] !== null && data[it] !== undefined) {
            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it])
            index++
          }
        }
      }
      return ret
    },

    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
export function resetTradePassword(data) {
  return request({
    url: '/user/uac/user/resetTradePassword',
    method: 'post',
    loading: true,
    data,
    transformRequest: data => {
      let index = 0
      let ret = ''

      for (const it in data) {
        if (data[it] !== undefined) {
          if (index > 0) {
            ret += '&'
          }
          if (data[it] !== null && data[it] !== undefined) {
            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it])
            index++
          }
        }
      }
      return ret
    },

    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
export function logout() {
  return request({
    url: '/user/uac/user/logout',
    method: 'get',
    loading: true
  })
}
export function checkRegSmsCode(data) {
  return request({
    url: '/api/login/checkRegSmsCode',
    method: 'post',
    data,
    loading: true
  })
}
export function bindPhone(data) {
  return request({
    url: '/user/uac/user/bindPhone',
    method: 'post',
    data,
    loading: true,
    transformRequest: data => {
      let index = 0
      let ret = ''

      for (const it in data) {
        if (data[it] !== undefined) {
          if (index > 0) {
            ret += '&'
          }
          if (data[it] !== null && data[it] !== undefined) {
            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it])
            index++
          }
        }
      }
      return ret
    },

    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
export function sendSms(data) {
  return request({
    url: '/pub/uac/user/sendSms',
    method: 'post',
    loading: true,
    data,
    transformRequest: data => {
      let index = 0
      let ret = ''

      for (const it in data) {
        if (data[it] !== undefined) {
          if (index > 0) {
            ret += '&'
          }
          if (data[it] !== null && data[it] !== undefined) {
            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it])
            index++
          }
        }
      }
      return ret
    },

    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
export function sendUserSms(data) {
  return request({
    url: '/user/uac/user/sendSms',
    method: 'post',
    loading: true,
    data,
    transformRequest: data => {
      let index = 0
      let ret = ''

      for (const it in data) {
        if (data[it] !== undefined) {
          if (index > 0) {
            ret += '&'
          }
          if (data[it] !== null && data[it] !== undefined) {
            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it])
            index++
          }
        }
      }
      return ret
    },

    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
export function sendBindPhoneSms(data) {
  return request({
    url: '/user/uac/user/sendBindPhoneSms',
    method: 'post',
    loading: true,
    data,
    transformRequest: data => {
      let index = 0
      let ret = ''

      for (const it in data) {
        if (data[it] !== undefined) {
          if (index > 0) {
            ret += '&'
          }
          if (data[it] !== null && data[it] !== undefined) {
            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it])
            index++
          }
        }
      }
      return ret
    },

    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
export function getAuthCode() {
  return process.env.BASE_API + '/pub/uac/validata/code/'
}
export function getVersion() {
  return request({
    url:
      window.location.protocol +
      '//' +
      window.location.host +
      '/static/js/version.json?' +
      Math.round(Math.random() * 1000000),
    method: 'get'
  })
}
export function sendEmail(data) {
  return request({
    url: '/pub/uac/user/sendEmail',
    method: 'post',
    loading: true,
    data,
    transformRequest: data => {
      let index = 0
      let ret = ''

      for (const it in data) {
        if (data[it] !== undefined) {
          if (index > 0) {
            ret += '&'
          }
          if (data[it] !== null && data[it] !== undefined) {
            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it])
            index++
          }
        }
      }
      return ret
    },

    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
export function resetPasswordByEmail(data) {
  return request({
    url: '/pub/uac/user/resetPasswordByEmail',
    method: 'post',
    loading: true,
    data,
    transformRequest: data => {
      let index = 0
      let ret = ''

      for (const it in data) {
        if (data[it] !== undefined) {
          if (index > 0) {
            ret += '&'
          }
          if (data[it] !== null && data[it] !== undefined) {
            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it])
            index++
          }
        }
      }
      return ret
    },

    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
export function sendBindEmailSms(data) {
  return request({
    url: '/user/uac/user/sendBindEmailSms',
    method: 'post',
    loading: true,
    data,
    transformRequest: data => {
      let index = 0
      let ret = ''

      for (const it in data) {
        if (data[it] !== undefined) {
          if (index > 0) {
            ret += '&'
          }
          if (data[it] !== null && data[it] !== undefined) {
            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it])
            index++
          }
        }
      }
      return ret
    },

    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
export function bindEmail(data) {
  return request({
    url: '/user/uac/user/bindEmail',
    method: 'post',
    data,
    loading: true,
    transformRequest: data => {
      let index = 0
      let ret = ''

      for (const it in data) {
        if (data[it] !== undefined) {
          if (index > 0) {
            ret += '&'
          }
          if (data[it] !== null && data[it] !== undefined) {
            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it])
            index++
          }
        }
      }
      return ret
    },

    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js